import { THoldingInfo, TPositions, TPrincipalPositions, TWalletData, TWalletProductInfo } from "../types/PrincipalPositionTypes";

type TFormatTableDistributionRelationsProps = {
    walletRelationsInfo: TWalletProductInfo[] ;
    principalPositionsList: TPrincipalPositions[];
};

export const FormatTableDistribution = (
  { walletRelationsInfo, principalPositionsList }: TFormatTableDistributionRelationsProps
): TWalletData => {

  const companys = agruparPositionsPorIsin(principalPositionsList);

  const result: TWalletData = {
    walletProductInfo: [],
    holdingInfo: [],
  };

  const others: THoldingInfo = {
    holdingName: "Others",
    holdingSumatory: 0,
    holdingFundWeight: []
  };

  result.walletProductInfo = walletRelationsInfo;

  companys.forEach((positions, isin) => {
    const localHolding: THoldingInfo = {
      holdingName: positions.length > 0 ? positions[0].name : 'Desconocido',
      holdingSumatory: 0,
      holdingFundWeight: []
    };

    const positionMap = new Map<string, TPositionConReferencia>();
    positions.forEach(pos => {
      positionMap.set(pos.principalIsin, pos);
    });

    const holdingXFunds = walletRelationsInfo.map(wallet => {
      const exist = positionMap.get(wallet.isin);
      return exist
        ? wallet.weight > 0.001
          ? Number((wallet.weight * exist.percentaje * 100).toFixed(2))
          : exist.percentaje * wallet.weight
        : 0;
    });

    const sumatory = holdingXFunds.reduce((acc, current) => acc + current, 0);

    others.holdingSumatory += sumatory;

    localHolding.holdingSumatory = Number(sumatory.toFixed(2));
    localHolding.holdingFundWeight = holdingXFunds;
    result.holdingInfo.push(localHolding);
  });

  const arrayFunds = result.holdingInfo.map(holds => holds.holdingFundWeight);
  const resultado = arrayFunds.reduce((acc, curr) => 
    acc.map((value, index) => value + curr[index])
  );

  const decimalsFormatSumatory = resultado.map(res => {
    return res > 0.01
      ? Number((100 - res).toFixed(2))
      : Math.floor((100 - res) * 100) / 100
  });

  others.holdingSumatory = Number((100 - others.holdingSumatory).toFixed(2));
  others.holdingFundWeight = decimalsFormatSumatory;

  result.holdingInfo = result.holdingInfo.sort((a, b) => b.holdingSumatory - a.holdingSumatory);
  
  result.holdingInfo.push(others);

  return result;
};

type TPositionConReferencia = TPositions & { principalIsin: string };

const agruparPositionsPorIsin = (data: TPrincipalPositions[]) => {
  const agrupados = new Map<string, TPositionConReferencia[]>();

  data.forEach(principal => {
    principal.positions.forEach(position => {
      const positionConRef: TPositionConReferencia = {
        ...position,
        principalIsin: principal.isin,
      };

      if (!agrupados.has(position.isin)) {
        agrupados.set(position.isin, []);
      }
      agrupados.get(position.isin)!.push(positionConRef);
    });
  });

  return agrupados;
};
